import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useDisableProductNfceMapping } from '@/features/productNfceMappings/hooks/useDisableProductNfceMapping'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

interface DisableProductNfceMappingModalProps {
  productNfceMappingId: string
  disabled?: boolean
}

export const DisableProductNfceMappingModal = ({
  productNfceMappingId,
  disabled,
}: DisableProductNfceMappingModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: disableMapping, isPending } = useDisableProductNfceMapping({
    productNfceMappingId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productNfceMappings'] })
      queryClient.invalidateQueries({ queryKey: ['productNfceMapping', productNfceMappingId] })
      setIsOpen(false)
    },
    onError: (error) => {
      setIsOpen(false)
      const errorMessages = (error as any)?.response?.data?.errors?.base
      if (errorMessages) {
        setMessages(errorMessages)
      }
    },
  })

  return (
    <>
      <Modal
        Trigger={
          <Button
            operationKlassToCheckPermission="Admin::ProductNfceMappings::Disable"
            type="button"
            variant="outline-error"
            disabled={disabled}
          >
            Desabilitar
          </Button>
        }
        title="Desabilitar mapeamento"
        subtitle="Tem certeza que deseja desabilitar este mapeamento de produto NFCe?"
        subtitleClassName="mt-1 text-white-300"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Confirmar"
        confirmButtonIsLoading={isPending}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onConfirm={() => disableMapping()}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
